var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-toolbar",
    [
      _c("h3", { staticClass: "md-title", staticStyle: { flex: "1" } }, [
        _vm._v(_vm._s(_vm.totalCount) + " " + _vm._s(_vm.resultType))
      ]),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "search", attrs: { "md-inline": "" } },
        [
          _c("label", [_vm._v("Search")]),
          _vm._v(" "),
          _c("md-input", {
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.startSearch(_vm.searchInput)
              }
            },
            model: {
              value: _vm.searchInput,
              callback: function($$v) {
                _vm.searchInput = $$v
              },
              expression: "searchInput"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-button",
        {
          staticClass: "md-icon-button",
          on: {
            click: function($event) {
              return _vm.startSearch(_vm.searchInput)
            }
          }
        },
        [_c("md-icon", [_vm._v("search")])],
        1
      ),
      _vm._v(" "),
      _vm.searchInput !== null && _vm.searchInput !== ""
        ? _c(
            "md-button",
            {
              staticClass: "md-icon-button",
              on: {
                click: function($event) {
                  return _vm.clearInput()
                }
              }
            },
            [_c("md-icon", [_vm._v("clear")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "md-toolbar-section-end" },
        [
          _c(
            "md-field",
            { staticClass: "orderby" },
            [
              _c("label", { attrs: { for: "sortFields" } }, [
                _vm._v("Order By:")
              ]),
              _vm._v(" "),
              _c(
                "md-select",
                {
                  attrs: { name: "sortFields", id: "sortFields" },
                  model: {
                    value: _vm.selectedSortField,
                    callback: function($$v) {
                      _vm.selectedSortField = $$v
                    },
                    expression: "selectedSortField"
                  }
                },
                _vm._l(_vm.sortFields, function(sortField, index) {
                  return _c(
                    "md-option",
                    { key: index, attrs: { value: sortField } },
                    [_vm._v(_vm._s(sortField))]
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("md-button", {
            domProps: { textContent: _vm._s(_vm.sortOrderText()) },
            on: {
              click: function($event) {
                return _vm.changeSort()
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fd5138e", { render: render, staticRenderFns: staticRenderFns })
  }
}